import React from 'react';
import styled from 'styled-components';
import { vars } from '../../theme';

export interface Props {
    percent: number;
    className?: string;
}

const HBFileAttachmentProgressBar = ({ percent, className }: Props) => (
    <div className={className}>
        <PercentageBar style={{ width: `${percent}%` }} />
    </div>
);

export default HBFileAttachmentProgressBar;

const PercentageBar = styled.div`
    height: 4px;
    background: ${vars.colors.base.accent};
    transition: all 0.2s linear;
`;
